const slider = document.querySelector('.js-slider');
// Create an intersection observer
const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		// Check if the slider is in the viewport
		if (entry.isIntersecting) {
			// Load the lazyloaded images inside the slider
			const lazyImages = entry.target.querySelectorAll('img');
			lazyImages.forEach(imgElement => {
				imgElement.setAttribute('loading', 'enger');
			});
			// init slider
			$(entry.target).slick({
				infinite: true,
				slidesToShow: 1,
				prevArrow: $('.js-slider-prev'),
				nextArrow: $('.js-slider-next'),
				breakpoints: {
					240: {
						perView: 1.5
					},
					767: {
						perView: 1
					}
				}
			});
			// Stop observing once the images are loaded
			observer.unobserve(entry.target);
		}
	});
});
observer.observe(slider);
